import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'; // https://react.i18next.com/latest/using-with-hooks
import Backend from 'i18next-http-backend'; // For lazy loading for translations: https://github.com/i18next/i18next-http-backend

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en-CA',
    supportedLngs: ['en-CA', 'fr-CA'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // locale files path
    },
    cleanCode: true,
    ns: ['common', 'pages'],
    defaultNS: 'common',
    fallbackLng: ['en-CA', 'fr-CA'],
  });

export default i18n;
